

















































import { Component, Vue } from 'vue-property-decorator';
import { Actions, Mutations, OverlayMods } from '@/ts/store/Constants';
import BookingData from '@/ts/BookingData';
import { mapGetters } from 'vuex';

@Component({
    computed: {
        ...mapGetters({
            requestIsActive: 'SharedFacilities/getUserBookingRequestsStatus',
        }),
    },
})

export default class BookedFacilityOverlay extends Vue {
    constructor() {
        super();
    }

    get mode(): string {
        return this.$store.getters['SharedFacilities/getBookedFacilityOverlayMode'];
    }

    get booking(): BookingData {
        return this.$store.getters['SharedFacilities/getUserSelectedBooking'];
    }

    get title(): string {
        switch (this.mode) {
            case OverlayMods.PreviewBooking.viewActive:
                return 'Your booking.';

            case OverlayMods.PreviewBooking.viewPrevious:
                return 'Your booking is completed.';

            case OverlayMods.PreviewBooking.deleted:
                return 'Booking has been canceled.';

            case OverlayMods.PreviewBooking.viewCongrats:
                return 'Your booking is created.';
        }
    }

    public cancelBooking() {
        this.$store.dispatch(Actions.CANCEL_USER_BOOKING, this.booking.id);
    }

    public goToBookings() {
        this.$store.commit(Mutations.SET_FACILITY_PAGE_DEFAULT_TAB, 1);

        this.cancel();
    }

    public cancel() {
        this.$store.commit(Mutations.SET_BOOKED_FACILITY_OVERLAY_VISIBILITY, false);
        this.$store.commit(Mutations.SET_BOOK_FACILITY_OVERLAY_VISIBILITY, false);
        this.$store.commit(Mutations.SET_FACILITY_DETAILS_OVERLAY_VISIBILITY, false);
        this.$store.commit(Mutations.SET_BOOKED_FACILITY_OVERLAY_MODE, OverlayMods.PreviewBooking.none);

        this.$nextTick(() => {
            this.$router.push({name: 'shared-facilities'});
        });
    }
}
